<template>
  <v-app>
    <v-app-bar app color="#08081B" dark>
      <div class="d-flex align-center">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          src="./assets/vodacom_logo.png"
          transition="scale-transition"
          width="40"
        />
        <v-toolbar-title>VodaPay Deep Link Generator</v-toolbar-title>
      </div>

      <v-spacer></v-spacer>

      <v-btn
        href="https://developer.vodapay.vodacom.co.za/mini-program"
        target="_blank"
        text
        class="d-none d-sm-block"
      >
        <span class="mr-2">Mini Programs Portal</span>
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>

      <template v-slot:extension>
        <v-tabs fixed-tabs :align-with-title="!isMobile()" v-model="tab">
          <v-tab href="#tab-1">Link Generation </v-tab>
          <v-tab href="#tab-2">Overview</v-tab>
          <v-tab href="#tab-3">Developer Docs</v-tab>
        </v-tabs>
      </template>
    </v-app-bar>

    <v-main>
      <v-tabs-items v-model="tab">
        <v-tab-item value="tab-1">
          <LinkGeneration />
        </v-tab-item>
        <v-tab-item value="tab-2"> <Overview /> </v-tab-item>
        <v-tab-item value="tab-3"> <DeveloperDocs /> </v-tab-item>
      </v-tabs-items>
    </v-main>
  </v-app>
</template>

<script>
import LinkGeneration from "./components/LinkGeneration";
import DeveloperDocs from "./components/DeveloperDocs";
import Overview from "./components/Overview";

export default {
  name: "App",

  components: {
    LinkGeneration,
    DeveloperDocs,
    Overview,
  },

  data: () => ({
    tab: null,
  }),
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
